module.exports = __webpack_public_path__ + "static/img/情久LOGO矢量图.4f906fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/情久LOGO矢量图.png
// module id = DzyW
// module chunks = 0